import * as d3 from "d3";
import {
    addGridlines,
    colonAnnotation, contextMenu, createTooltip, generateDownloadData,
    inrFormatter,
    numberFormat,
    responsivefy, wraps
} from '../functions'

export default function (chart, divId, vizName,resData, filterParam,checkbox,gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = (chart.axisLabelFontSize - 4) + "px"
    //var tempVar = chart.tempVar

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    // axios.post(url, filterParam).then(response => {
        let data = resData
        var totalAmount = 0;

        for (var i = 0; i < data.length; i++) {
            data[i].metric1 = +data[i].metric1;
            totalAmount += data[i].metric1;
            if (i > 0) {
                data[i]['CumulativeAmount'] = data[i].metric1 + data[i - 1].CumulativeAmount;
            } else {
                data[i]['CumulativeAmount'] = data[i].metric1;
            }
        }
        //now calculate cumulative % from the cumulative amounts & total, round %
        for (let i = 0; i < data.length; i++) {
            data[i]['CumulativePercentage'] = (data[i]['CumulativeAmount'] / totalAmount) * 100;
            data[i]['CumulativePercentage'] = parseFloat(data[i]['CumulativePercentage'].toFixed(2));
        }

        //Axes and scales
        var x1Scale = d3.scaleBand().rangeRound([0, chart.width]).paddingInner(.1);
        x1Scale.domain(data.map(function (d) {
            return d.dim1_name;
        }));

        var y1Scale = d3.scaleLinear()
            .domain([0, d3.max(data, function (d) {
                return d.metric1;
            })])
            .range([chart.height, 0]);

        var y2Scale = d3.scaleLinear().domain([0, 100]).range([chart.height, 0]);

        var x1AxisLabel = d3.axisBottom().scale(x1Scale)

        var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickFormat((d) => {
            return inrFormatter(d)
        });

        var y2AxisLabel = d3.axisRight().scale(y2Scale)

        const jsonData = chart.x1AxisLabelCharLimitsJson;
        console.log("json data",chart.x1AxisLabelCharLimitsJson);
        // Extract values into separate variables
        const charecter = jsonData.break.value1;
        const charecter1 = jsonData.break.value2;
        const value2RegExp = new RegExp(charecter1.slice(1, -1));

        //Draw svg
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId).append("svg")
            .attr("width", chart.width + chart.margin.left + chart.margin.right)
            .attr("height", chart.height + 4 * chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append("g")
            .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

        /*d3.select(".d3-tipparetoBar"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
            var y1tip =  tooltip_class()

            y1tip.attr('class', 'd3-tipparetoBar'+divId.id)
                .html((d) =>{
                    return(chart.y1MetricTooltip+ colonAnnotation+ d.dim1_name+ "</br>"
                            + chart.y2MetricTooltip+ colonAnnotation+ inrFormatter(d.metric1)+ "</span>")
                })

            svg.call(y1tip)

            d3.select(".d3-tipparetoLine"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
            var y2tip = tooltip_class()

            y2tip.attr('class', 'd3-tipparetoLine'+divId.id)
                    .html((d) =>{ return(chart.x2MetricTooltip+ colonAnnotation+ numberFormat(d.dim1_id) + "<br/>"
                        + chart.x1MetricTooltip+ colonAnnotation+ inrFormatter(d.CumulativePercentage) + "%<br/>"
                        + chart.x2AxisDisplayName+ colonAnnotation+ numberFormat(d.CumulativeAmount)
                    )
            })

            //svg.call(y2tip)*/
        if (gridflag === true) {
            addGridlines(svg, x1Scale, y1Scale, chart);
        }
        // d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        // var div = d3.select(divId).append('div').attr('class', 'tooltip')
        //     .attr('style', 'position: absolute; opacity: 0;')

        const tooltip = createTooltip(divId);

        // Add <defs> and <clipPath> to the SVG
        svg.append("defs")
            .append("svg:clipPath")
            .attr("id", "clip")
            .append("svg:rect")
            .attr("x", 0)
            .attr("y", -10)
            .attr("width", chart.width)   // Clip width matches chart width
            .attr("height", chart.height); // Clip height matches chart height

        // Append a group with clipPath applied
        const contentGroup = svg.append("g")
            .attr("class", "content")
            .attr("clip-path", "url(#clip)");

        svg.append('text')
            .attr('x', (chart.width / 3) + 100)
            .attr('y', chart.height + chart.margin.bottom + 14 * chart.axisLabelDistance - 50)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left + 160)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '-7em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', chart.width + chart.margin.right - chart.vizSpecific1)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y2AxisDisplayName)
            .style('font-size', fontSize)

        //Draw histogram
        contentGroup.selectAll(".bar")
            .data(data)
            .enter()
            .append("rect")
            .attr("class","bar")
            .attr("fill", "steelblue")
            .attr("x", function (d) {
                return x1Scale(d.dim1_name);
            })
            .attr("width", x1Scale.bandwidth())
            .attr("y", function (d) {
                return y1Scale(d.metric1);
            })
            .attr("height", function (d) {
                return chart.height - y1Scale(d.metric1);
            })
            .on('mouseover', function(d) {
                tooltip.onMouseOver(d, this, data => chart.x1DataFieldName == null ? chart.y1MetricTooltip + colonAnnotation + data.dim1_name + "</br>"
                    + chart.y2MetricTooltip + colonAnnotation + inrFormatter(data.metric1) + "</span>" :
                    chart.y1MetricTooltip + colonAnnotation + data.dim1_name + "</br>"
                    + chart.y2MetricTooltip + colonAnnotation + inrFormatter(data.metric1) + "</br>"
                    + chart.x1DataFieldName + colonAnnotation + inrFormatter(data.metric2) + "</span>")  // Pass tooltip content
            })
            .on('mousemove', tooltip.onMouseMove)
            .on('mouseleave', function() {
                tooltip.onMouseLeave(this);
            })
            .on('contextmenu', function(d) {
                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name]               // e.g., "metric1"
                };
                console.log("clickedData",clickedData);
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                d3.event.preventDefault();
            });
            // .on("mousemove", function (d) {
            //     console.log(d3.event, d)
            //     div.transition()
            //         .duration(200)
            //         .style("opacity", .9);
            //     div.html(chart.x1DataFieldName == null ? chart.y1MetricTooltip + colonAnnotation + d.dim1_name + "</br>"
            //         + chart.y2MetricTooltip + colonAnnotation + inrFormatter(d.metric1) + "</span>" :
            //         chart.y1MetricTooltip + colonAnnotation + d.dim1_name + "</br>"
            //         + chart.y2MetricTooltip + colonAnnotation + inrFormatter(d.metric1) + "</br>"
            //         + chart.x1DataFieldName + colonAnnotation + inrFormatter(d.metric2) + "</span>"
            //     )
            //         .style("left", (d3.event.pageX) + "px")
            //         .style("top", (d3.event.pageY) + "px");
            // })
            // .on("mouseout", function () {
            //     div.transition().style("opacity", 0)
            // })
        //.on("mouseover", y1tip.show)
        //.on("mouseout", y1tip.hide)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        // bar.append("rect")
        //     .attr("x", function (d) {
        //         return x1Scale(d.dim1_name);
        //     })
        //     .attr("width", x1Scale.bandwidth())
        //     .attr("y", function (d) {
        //         return y1Scale(d.metric1);
        //     })
        //     .attr("height", function (d) {
        //         return chart.height - y1Scale(d.metric1);
        //     });

        // var bar2= svg.selectAll(".bar")
        //     .data(data)
        //     .enter().append("g")
        //     .attr("fill", "grey")
        // .on("mousemove", function(d) {
        //     console.log(d3.event, d)
        //     div.transition()
        //         .duration(200)
        //         .style("opacity", .9);
        //     div.html(chart.y1MetricTooltip+ colonAnnotation+ d.dim1_name+ "</br>"
        //         + chart.y2MetricTooltip+ colonAnnotation+ inrFormatter(d.metric1)+ "</span>"
        //     )
        //         .style("left", (d3.event.layerX ) + "px")
        //         .style("top", (d3.event.layerY ) + "px");
        // })
        // .on("mouseout", function() { div.transition().style("opacity", 0) })
        //.on("mouseover", y1tip.show)
        //.on("mouseout", y1tip.hide)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        // bar2.append("rect")
        //     .attr("x", 8)
        //     .attr("width", function(d,i) { return d.CummulativePercentage[i]>80 ? x1Scale(d.dim1_name[i]) + x1Scale.bandwidth() : x1Scale.bandwidth() })
        //     .attr("y", function(d) { return y2Scale(d.CumulativePercentage); })
        //     .attr("height",  chart.height - 40);

        //Draw CDF line
        var guide = d3.line()
            .x(function (d) {
                return x1Scale(d.dim1_name) + x1Scale.bandwidth() / 2;
            })
            .y(function (d) {
                return y2Scale(d.CumulativePercentage)
            });

        contentGroup.selectAll(".line")
            .data([data])  // Binds data to the line
            .join("path")
            .attr("class", "line")
            .attr('d', guide)
            .attr('fill', "none")
            .attr('stroke', 'purple')
            .attr("stroke-width", "1.5px")

        contentGroup.selectAll(".dot")
            .data(data)
            .enter()
            .append("circle")
            .attr("class","dot")
            .attr("r", 5)
            .attr("cx", function (d) {
                return x1Scale(d.dim1_name) + x1Scale.bandwidth() / 2;
            })
            .attr("cy", function (d) {
                return y2Scale(d.CumulativePercentage);
            })
            .style("fill", "purple")
            .on('mouseover', function(d) {
                tooltip.onMouseOver(d, this, data => chart.x1DataFieldName == null ? chart.x2MetricTooltip + colonAnnotation + numberFormat(data.dim1_id) + "<br/>"
                    + chart.x1MetricTooltip + colonAnnotation + inrFormatter(data.CumulativePercentage) + "%<br/>"
                    + chart.x2AxisDisplayName + colonAnnotation + numberFormat(data.CumulativeAmount)
                    : chart.x2MetricTooltip + colonAnnotation + numberFormat(data.dim1_id) + "<br/>"
                    + chart.x1MetricTooltip + colonAnnotation + inrFormatter(data.CumulativePercentage) + "%<br/>"
                    + chart.x2AxisDisplayName + colonAnnotation + numberFormat(data.CumulativeAmount) + "</br>"
                    + chart.x1DataFieldName + colonAnnotation + inrFormatter(data.metric2))  // Pass tooltip content
            })
            .on('mousemove', tooltip.onMouseMove)
            .on('mouseleave', function() {
                tooltip.onMouseLeave(this);
            })
            .on('contextmenu', function(d) {

                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name]               // e.g., "metric1"
                };
                console.log("clickedData",clickedData);
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                d3.event.preventDefault();
            });
            // .on("mousemove", function (d) {
            //     console.log(d3.event, d)
            //     div.transition()
            //         .duration(200)
            //         .style("opacity", .9);
            //     div.html(chart.x1DataFieldName == null ? chart.x2MetricTooltip + colonAnnotation + numberFormat(d.dim1_id) + "<br/>"
            //         + chart.x1MetricTooltip + colonAnnotation + inrFormatter(d.CumulativePercentage) + "%<br/>"
            //         + chart.x2AxisDisplayName + colonAnnotation + numberFormat(d.CumulativeAmount)
            //         : chart.x2MetricTooltip + colonAnnotation + numberFormat(d.dim1_id) + "<br/>"
            //         + chart.x1MetricTooltip + colonAnnotation + inrFormatter(d.CumulativePercentage) + "%<br/>"
            //         + chart.x2AxisDisplayName + colonAnnotation + numberFormat(d.CumulativeAmount) + "</br>"
            //         + chart.x1DataFieldName + colonAnnotation + inrFormatter(d.metric2)
            //     )
            //         .style("left", (d3.event.pageX) + "px")
            //         .style("top", (d3.event.pageY) + "px")
            // })
            // .on("mouseout", function () {
            //     div.transition().style("opacity", 0)
            // })
        //.on("mouseover", y2tip.show)
        //.on("mouseout", y2tip.hide);
        //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID

        //Draw axes
        svg.append("g")
            .attr("class", "x-axis")
            .attr("transform", "translate(0," + chart.height + ")")
            .call(x1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'end')
            .attr('dx', '-0.6em')
            .attr('dy', '0.1em')
            .attr('transform', 'rotate(-50)')
            .call(wraps, charecter, value2RegExp);

        svg.append("g")
            .attr("class", "y-axis")
            .call(y1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .append("text")
            .attr("transform", "rotate(-90)")
            .attr("y", 6)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .text("metric1");

        svg.append("g")
            .attr("class", "y1-axis")
            .attr("transform", "translate(" + [chart.width, 0] + ")")
            .call(y2AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .append("text")
            .attr("transform", "rotate(-90)")
            .attr("y", 4)
            .attr("dy", "-.71em")
            .style("text-anchor", "end")
            .text("Cumulative %");

        var zoomBehaviour = d3.zoom()
            .scaleExtent([0.5,5])
            .on("zoom",zoomed);

        contentGroup
            .insert("rect","rect")
            .attr("width", chart.width)
            .attr("height", chart.height)
            .attr("fill", "none")
            .attr("pointer-events", "all")
            .call(zoomBehaviour);

        function zoomed(){
            var zoomState = d3.zoomTransform(this);
             x1Scale.range([0,zoomState.k * (chart.width-chart.margin.right)]);
            var newY1Scale = zoomState.rescaleY(y1Scale);
            var newY2Scale = zoomState.rescaleY(y2Scale);


            svg.select(".x-axis").call(d3.axisBottom(x1Scale));

            svg.select(".y-axis").call(d3.axisLeft(newY1Scale).tickFormat((d) => {
                return inrFormatter(d)
            }));
            svg.select(".y1-axis").call(d3.axisRight(newY2Scale));


            contentGroup.selectAll(".bar").attr("x", function (d) {
                return x1Scale(d.dim1_name);
            }).attr("width", x1Scale.bandwidth())
                // .attr("y", (d) => newY1Scale(d.metric1))
                // .attr("height", function (d) {
                //     return chart.height - newY1Scale(d.metric1);
                // });

            contentGroup.selectAll(".line").attr("d", guide.x((d) => x1Scale(d.dim1_name))
                .y((d)=>newY2Scale(d.CumulativePercentage)));


            // Update the circles (dots) to move accordingly
            contentGroup.selectAll(".dot")
                .attr("cx", function(d) {
                    return x1Scale(d.dim1_name);
                })
                .attr("cy", function(d) {
                    return newY2Scale(d.CumulativePercentage);
                });
        }
    // })
}
